/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { io } from 'socket.io-client';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class SocketService {
  socket: any;
  url: string = '';
  constructor() {}

  initSocket(): void {
    if (this.socket && this.socket.connected) {
      return;
    }
    const token = localStorage.getItem(`${environment.storageKey}`);
    if (token && token !== 'undefined') {
      if (this.socket) {
        this.socket.disconnect();
      }
      this.url = `${environment.socket_url}?token=${token}&role=SERVICE_PROVIDER&sentBy=SERVICE_PROVIDER`;
      this.socket = io(this.url, {
        reconnection: true,
        query: {
          token,
          role: 'SERVICE_PROVIDER',
          sentBy: 'SERVICE_PROVIDER',
        },
      });
    }
  }

  emitAction(action: any, payload: any): void {
    if (this.socket) {
      this.socket.emit(action, payload);
    }
  }

  public onEvent(event: string): Observable<any> {
    return new Observable<any>(observer => {
      if (!this.socket) return;
      const handler = (data: any) => observer.next(data);
      this.socket.on(event, handler);
      return () => {
        if (this.socket) {
          this.socket.off(event, handler);
        }
      };
    });
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}
